import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-action-row',
    template: `
    <div class="tw-flex  tw-w-full tw-items-center">
      <div class="tw-pr-2">
        <ng-content select="[left1]"></ng-content>
      </div>
      @if (!hasTwoColHeader) {
        <div class="tw-pr-2">
          <ng-content select="[left2]"></ng-content>
        </div>
      }
      @if (!hasTwoColHeader) {
        <div class="tw-pr-2">
          <ng-content select="[left3]"></ng-content>
        </div>
      }
    
      <div class="tw-grow"></div>
      @if (!hasTwoColHeader) {
        <div class="tw-pr-2">
          <ng-content select="[right3]"></ng-content>
        </div>
      }
      @if (!hasTwoColHeader) {
        <div class="tw-pr-2">
          <ng-content select="[right2]"></ng-content>
        </div>
      }
      <div class="tw-pr-2">
        <ng-content select="[right1]"></ng-content>
      </div>
    </div>
    `,
    styles: [``],
    standalone: false
})
export class ActionRowComponent {
  @Input()
  hasTwoColHeader: boolean = false;

  constructor() {}
}
